import { httpRequest } from "@services/http";
import { AggregateVersion } from "@models/aggregateVersion.model";

/**
 * One contract's term history (MPN-1336).
 *
 * No contract-specific version model: the response is exactly `AggregateVersion`. An ingest
 * version carries a run count because runs pin it; nothing pins a contract version, so there is
 * no extra field to model.
 */
export class CommandListContractVersions {
  async run(contractId: number): Promise<AggregateVersion[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/config-versions/`;
    return httpRequest<AggregateVersion[]>(url, { method: "GET" });
  }
}

/** Domain triggers on top of the universal three. Read with the author, never alone: the system
 *  user is behind the rollout baselines and the metric-key renames, which read differently. */
export const CONTRACT_TRIGGER_LABELS: Record<string, string> = {
  metric_key_renamed: "renamed a metric key",
  pricing_repaired: "pricing repair run",
};
